import React from 'react'
import SwipeableViews from 'react-swipeable-views'
import { Trans } from '@lingui/react/macro'

import ToggleComponent from '../ToggleComponent'
import PaymentContent from '../PaymentContent'

import styles from './index.module.scss'

import type { IPaymentContentProps } from '../PaymentContent'
import type { IToggleComponentProps } from '../ToggleComponent'

import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'
import { CssIcon } from '@/components/CssIcon'
import { useAppUIModal } from '@/contexts/AppUIModalContext'


import { tw, cls } from 'tagged-classnames-free';
export interface IInnerContentProps {
  className?: string
  toggleComponentProps?: IToggleComponentProps
  ulClassName?: string
  children?: React.ReactNode
  buyClassName?: string
  payClassName?: string
  backClassName?: string
  backBtnClassName?: string
  BeforeBuyContent?: React.ReactNode
  AfterBuyContent?: React.ReactNode
  PayContent?: React.ReactNode
  paymentContentProps: IPaymentContentProps
  SignUpBox?: React.ReactNode
  isAnonymousPayment?: boolean
}

const InnerContent: React.FC<IInnerContentProps> = (props) => {
  const {
    className,
    toggleComponentProps,
    ulClassName,
    children,
    buyClassName,
    payClassName,
    BeforeBuyContent,
    AfterBuyContent,
    PayContent,
    paymentContentProps,
    SignUpBox,
    backClassName,
    backBtnClassName,
    isAnonymousPayment,
  } = props

  const { isSignIn } = useSessionInfo()
  const { upgradePlan } = useAppUIModal()
  const { data } = upgradePlan

  const {
    step,
    onChangeBuyStep,
    payDivContentRef,
    buyDivContentRef,
    isModal,
    paymentPlatformInfo,
  } = paymentContentProps.payStepInfo

  const { firstPaymentPlatformIsPayinsider } = paymentPlatformInfo

  return (
    <div
      className={tw`
        w-full
        ${className}
      `}
    >
      <SwipeableViews
        disabled
        index={step}
        slideClassName={cls`
          ${styles.slide}
        `}
      >
        {/* 购买流程 */}
        <div
          ref={buyDivContentRef}
          className={tw`
            pb-2 pt-5 md:px-10
            ${buyClassName}
          `}
        >
          {/* 显示唤起支付弹窗的原因 */}
          {data?.reason && isModal && (
            <div className='mb-5 text-center text-xl leading-10 text-white md:text-4xl'>
              {data?.reason}
            </div>
          )}
          {BeforeBuyContent}
          {toggleComponentProps?.durationProps ? (
            <ToggleComponent {...toggleComponentProps} />
          ) : null}
          <ul
            className={tw`
              grid
              grid-cols-1
              gap-6 md:grid-cols-3
              ${ulClassName}
            `}
          >
            {children}
          </ul>
          {AfterBuyContent}
        </div>
        {/* 注册或者付费流程 */}
        <div
          ref={payDivContentRef}
          className={tw`
            relative px-2
            ${payClassName}
          `}
        >
          <div
            className={tw`
              mx-auto
              mb-3 flex items-center justify-start gap-x-3
              ${backClassName}
            `}
          >
            <button
              type='button'
              className={tw`
                text-f-text-tertiary flex items-center text-xs
                ${backBtnClassName}
              `}
              onClick={() => {
                onChangeBuyStep()

                setTimeout(() => {
                  buyDivContentRef?.current?.scrollIntoView({
                    behavior: 'instant',
                    block: 'center',
                  })
                }, 50)
              }}
            >
              <CssIcon className='i-com--back-fill w-4' />
              <Trans>Back</Trans>
            </button>
          </div>
          <div>
            {(isAnonymousPayment && !firstPaymentPlatformIsPayinsider) ||
            isSignIn ? (
              <PaymentContent {...paymentContentProps} />
            ) : (
              <div className='flex justify-center'>{SignUpBox}</div>
            )}
          </div>
        </div>
      </SwipeableViews>
    </div>
  )
}

export default InnerContent
